import React from 'react';
import { AccordionPanel } from '../../../../../../../components/AccordionPanel';
import { ApplicationFormTemplateRow } from '../ApplicationFormTemplateRow';
import { SurveySection } from '../../../../../../../entities/survey_engine/SurveySection';
import { SurveyQuestion } from '../../../../../../../entities/survey_engine/SurveyQuestion';
import { placeholder } from '../../../../JobPostPage/ApplicationFormTab/utils/placeholder';

interface PropTypes {
  section: SurveySection;
}

export function ApplicationFormTemplateSection(props: PropTypes) {
  return (
    <AccordionPanel
      key={props.section.id}
      title={<a className='fw-bold'>{props.section.sectionName}</a>}
      className={'mb-4'}
      itemClassName='border-blue-gray-500'
      id={props.section.id.toString()}
      opened
    >
      <>
        {props.section.questions.map((question: SurveyQuestion) => {
          return (
            <ApplicationFormTemplateRow
              key={question.id}
              title={question.title}
              placeholder={placeholder(question)}
              selected={question.type}
              mandatory={question.mandatory}
            />
          );
        })}
      </>
    </AccordionPanel>
  );
}
